/**
 * NOS-63: Validation for custom domain input.
 * Valid domain format, no protocol prefix.
 */

const DOMAIN_REGEX = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/
const PROTOCOL_PREFIX = /^(https?:\/\/|www\.)/i

export interface DomainValidation {
  valid: boolean
  error?: string
}

export function validateCustomDomain(input: string): DomainValidation {
  const normalized = input.trim().toLowerCase()
  if (normalized.length === 0) {
    return { valid: false, error: "Domain is required" }
  }
  if (PROTOCOL_PREFIX.test(normalized)) {
    return { valid: false, error: "Do not include protocol (https://) or www. prefix" }
  }
  if (normalized.length < 4) {
    return { valid: false, error: "Domain is too short" }
  }
  if (normalized.length > 253) {
    return { valid: false, error: "Domain is too long" }
  }
  if (!DOMAIN_REGEX.test(normalized)) {
    return { valid: false, error: "Enter a valid domain (e.g. donate.example.org)" }
  }
  return { valid: true }
}
